import { GenexActions, GenexSurveyTypes } from 'core/enums/genex';
import { GenexModal } from 'core/services/api/surveys/genex/genex-survey';
import { _noop } from 'utils/function.utils';

type MethodPointer = (...args: any[]) => void | (() => void);

export interface Store {
  lang?: string;
  isInitialised: boolean;
  methodPointer: MethodPointer;
  current: GenexActions;
  type: GenexSurveyTypes;
  customerNumber: string;
  userEmail: string;
  modal: GenexModal;
  useMAHDemographics: boolean;
  optionalUserData?: OptionalUserData;
  surveyLink?: string;
  uniqueInteractionId?: string;
  initialize: (type: GenexSurveyTypes | null, userEmail: string | null, lang?: string) => void;
  triggerSurvey: (
    model: ModelWithCategory,
    customerNumber: string,
    timestamp: Date,
    onStopSurvey?: (id: string, link: string) => void,
  ) => void;
  registerCompleteCallback: () => void;
  openSurvey: () => void;
  saveUserData: (userData: OptionalUserData) => void;
}

export interface Demographic {
  //demographic structure will always adhere to this format.
  demographics_type_id: number;
  demographics_value: string;
}

// const customerNumber = "120840373";
// const email = 'soltest15@rewards.co.za'; //temporarily populating with test data. Patrick to advise on best method to get email.

export interface ModelWithCategory {
  category: GenexActions;
  outcome: string;
  journeyName?: string;
  surveyName?: string;
  errorCode?: string;
  language?: string;
  eventDescription?: string;
}

export interface OptionalUserData {
  phoneNumber?: string;
  userName?: string;
  country?: string;
  countryCode?: string;
  smartCardNumber?: string;
  highestPrincipalPackage?: string;
  customerAccountType?: string;
}